export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/e0ab7379baf600f9962514af15119239.png";